import { NgModule, ModuleWithProviders } from '@angular/core';

import { DateFormatService } from './date-format.service';

@NgModule()
export class DateFormatModule {
	static forRoot(): ModuleWithProviders<DateFormatModule> {
		return {
			ngModule: DateFormatModule,
			providers: [DateFormatService]
		};
	}
}
